module.exports = __webpack_public_path__ + "img/knot.f8b37da5.svg";